module.exports = __webpack_public_path__ + "img/srn.d81c354c.svg";